import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { applyMiddleware, createStore } from "redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import reduxThunk from "redux-thunk";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import App from "./App";
import rootReducer from "./store";

const jwtToken = localStorage.getItem("HOST_TOKEN");

const store = createStore(
  rootReducer,
  {
    auth: {
      token: jwtToken,
      isAuthenticated: jwtToken ? true : false,
    },
  },
  applyMiddleware(reduxThunk)
);

const persistor = persistStore(store);

createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

serviceWorker.unregister();
